// Element.dataset polyfill for MAG254
try {
  const datasetPropertyDescriptor = Object.getOwnPropertyDescriptor(Element.prototype, 'dataset');

  if (
    !document.documentElement.dataset &&
    // FF is empty while IE gives empty object
    (!datasetPropertyDescriptor || !datasetPropertyDescriptor.get)
  ) {
    const propDescriptor: PropertyDescriptor & ThisType<Element> = {
      enumerable: true,
      get: function () {
        'use strict';

        const that = this;
        let HTML5_DOMStringMap;
        let attrVal;
        let attrName;
        let propName;
        let attribute;
        const attributes = this.attributes;
        const attsLength = attributes.length;

        const capitalize = function (n0: string) {
          return n0.charAt(1).toUpperCase();
        };

        const getter = function () {
          return this;
        };

        const setter = function (_attrName, value) {
          return typeof value !== 'undefined' ? this.setAttribute(_attrName, value) : this.removeAttribute(_attrName);
        };

        try {
          // Simulate DOMStringMap w/accessor support
          // Test setting accessor on normal object
          ({}).__defineGetter__('test', function () {});
          HTML5_DOMStringMap = {};
        } catch (e1) {
          // Use a DOM object for IE8
          HTML5_DOMStringMap = document.createElement('div');
        }

        for (let i = 0; i < attsLength; i++) {
          attribute = attributes[i];
          // Fix: This test really should allow any XML Name without
          //         colons (and non-uppercase for XHTML)
          if (attribute && attribute.name && /^data-\w[\w\-]*$/.test(attribute.name)) {
            attrVal = attribute.value;
            attrName = attribute.name;
            // Change to CamelCase
            propName = attrName.substr(5).replace(/-./g, capitalize);
            try {
              Object.defineProperty(HTML5_DOMStringMap, propName, {
                enumerable: this.enumerable,
                get: getter.bind(attrVal || ''),
                set: setter.bind(that, attrName),
              });
            } catch (e2) {
              // if accessors are not working
              HTML5_DOMStringMap[propName] = attrVal;
            }
          }
        }
        return HTML5_DOMStringMap;
      },
    };

    try {
      // FF enumerates over element's dataset, but not
      //   Element.prototype.dataset; IE9 iterates over both
      Object.defineProperty(Element.prototype, 'dataset', propDescriptor);
    } catch (e) {
      propDescriptor.enumerable = false; // IE8 does not allow setting to true
      Object.defineProperty(Element.prototype, 'dataset', propDescriptor);
    }

    console.log('[Polyfills] Element.dataset polyfill added.');
  }
} catch (error) {
  console.error('[Polyfills] Unable to polyfill Element.dataset', error);
}
